import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { BorderedTablePaper } from "@/pages/heat-report/styles/HeatReportStyledComponents";
import { Box } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./hooks/useTableData";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const AdditionsTable = () => {
  const {
    state: { additions, lmfProcessData },
  } = useHeatReportContext();

  const tableKey = `probes-table-${lmfProcessData?.ProcessId || "default"}`;

  const { columns } = useTableData();
  return (
    <BorderedTablePaper elevation={0}>
      <Box p={1}>
        <div style={{ height: "20rem" }} key={tableKey}>
          <AgGridReact
            rowData={additions}
            columnDefs={columns}
            defaultColDef={defaultColDef}
            getRowId={(params) => params.data.AdditionId}
            {...defaultGridOptions}
          />
        </div>
      </Box>
    </BorderedTablePaper>
  );
};
